(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("moment"), require("@alifd/next"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "moment", "@alifd/next", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["BizComps"] = factory(require("react"), require("moment"), require("@alifd/next"), require("react-dom"));
	else
		root["BizComps"] = factory(root["React"], root["moment"], root["Next"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__21__, __WEBPACK_EXTERNAL_MODULE__22__, __WEBPACK_EXTERNAL_MODULE__31__) {
return 